import intersection from 'lodash/intersection'

export const genHasEntitlements = claims => (isl, options = {}) => {
  if (!claims?.isl) {
    return false
  }

  isl = isl ? [isl].flat() : []

  const commonCount = intersection(
    isl,
    claims.isl.map(entitlement => entitlement)
  ).length

  return options.all ? commonCount === isl.length : !!commonCount
}

export const AUDIENCE_NAME_MAP = {
  'Cyber Crime': 'INTEL_CYB_CRIME',
  'Cyber Espionage': 'INTEL_CYB_ESP',
  'Cyber Physical': 'INTEL_CYB_PHYS',
  Freemium: 'INTEL_NAUT_FREE',
  Fusion: 'INTEL_RBI_FUS',
  Hacktivism: 'INTEL_HACK',
  'Media Highlights': '*',
  Operational: 'INTEL_RBI_OPS',
  Strategic: 'INTEL_RBI_EXEC',
  Vulnerability: 'INTEL_RBI_VULN',

  // TSAPI /collections/reports
  'cyber-crime': 'INTEL_CYB_CRIME',
  'cyber-espionage': 'INTEL_CYB_ESP',
  'cyber-physical': 'INTEL_CYB_PHYS',
  freemium: 'INTEL_NAUT_FREE',
  fusion: 'INTEL_RBI_FUS',
  hacktivism: 'INTEL_HACK',
  operational: 'INTEL_RBI_OPS',
  strategic: 'INTEL_RBI_EXEC',
  vulnerability: 'INTEL_RBI_VULN',
}

export const AUDIENCE_SHORT_ID_MAP = {
  intel_cc: 'INTEL_CYB_CRIME',
  intel_ce: 'INTEL_CYB_ESP',
  intel_ci: 'INTEL_CYB_PHYS',
  intel_exec: 'INTEL_RBI_EXEC',
  intel_free: 'INTEL_NAUT_FREE',
  intel_fusion: 'INTEL_RBI_FUS',
  intel_hack: 'INTEL_HACK',
  intel_oper: 'INTEL_RBI_OPS',
  intel_vuln: 'INTEL_RBI_VULN',
}

export const AUDIENCE_MAP = {
  ...AUDIENCE_NAME_MAP,
  ...AUDIENCE_SHORT_ID_MAP,
}

export const userAccessToResource = (object, hasEntitlements) => {
  if (!object) {
    return false
  }

  /** Vuln check to be removed once data has redacted fields ************/
  if (object.id?.toString()?.startsWith('vulnerability')) {
    return true
  }

  if (object.intel_free) {
    return true
  }

  let entitlements

  // Backward compatibility for objects that have "license_info" like { intel_cc: true, ... }
  if (typeof object.license_info === 'object') {
    entitlements = Object
      .entries(object.license_info)
      .map(([key, bool]) => bool ? AUDIENCE_MAP[key] : undefined)
      .filter(Boolean)
  }

  // Backward compabitility for naut API's promoted reports, which stores audience as a single string
  if (typeof object.audience === 'string') {
    entitlements = [object.audience]
  }

  // Backward compat for reports which have an array of human readable audience names like
  // ['Cyber Crime'] OR intel v4 audience short names like ['intel_cc']
  if (Array.isArray(object.audience) && typeof object.audience[0] === 'string') {
    entitlements = object.audience.map(audience => AUDIENCE_MAP[audience]).filter(Boolean)
  }

  // Expected audience, array like [{ license: 'INTEL_RBI_FUS' }, ...]
  // Relevant reports (on the actor widgets) with Freemium access have no audience.label variable identifying
  // their Freemium status, only 'name'
  if (Array.isArray(object.audience) && typeof object.audience[0] === 'object') {
    entitlements = object.audience.map(audience => (audience.license || audience.name))
  }

  if (entitlements) {
    // Some users (at least in QA) don't have INTEL_NAUT_FREE.  If an object is "free", anyone can see it,
    // so we can probably ignore entitlements
    // The value '*' is used as a catch-all entitlement for which we don't have an isl value for
    return entitlements.includes('*') || entitlements.includes('INTEL_NAUT_FREE') || entitlements.includes('Freemium') || hasEntitlements(entitlements)
  }

  return false
}
